<script lang="ts" setup>
import { DrawerRoot } from 'vaul-vue'

const props = withDefaults(defineProps<{
  open?: boolean
  shouldScaleBackground?: boolean
}>(), {
  shouldScaleBackground: true,
})

const emits = defineEmits<{
  (e: 'update:open', value: boolean): void
}>()
</script>

<template>
  <DrawerRoot
    :open="props.open"
    :should-scale-background="props.shouldScaleBackground"
    @update:open="emits('update:open', $event)"
  >
    <slot />
  </DrawerRoot>
</template>
